import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ccoActions from "../../../../_actions/ccoActions";

class EditCcoModal extends Component {
  state = {
    formData: {
      projectId: 0,
      ccoId: 0,
      ccoNo: "",
      supplementNo: "",
      description: "",
      selectedLocations: null,
      locationIds: [],
    },
    formErrors: {
      ccoNo: null,
      supplementNo: null,
      description: null,
    },
  };

  componentDidMount() {
    const { projectId, ccoDetails: cco, isNew, projLocationList } = this.props;

    if (cco && !isNew) {
      let selectedLocations = [];
      if (projLocationList && cco.locationIds.length > 0) {
        selectedLocations = projLocationList
          .map((l) => ({ value: l.locationId, label: l.name }))
          .filter((l) => cco.locationIds.includes(l.value));
      }
      this.setState({
        formData: {
          ...this.state.formData,
          projectId,
          ccoId: cco.ccoId,
          ccoNo: cco.ccoNo,
          supplementNo: cco.supplementNo || "",
          description: cco.description || "",
          selectedLocations,
          locationIds: cco.locationIds,
        },
      });
    }
  }

  handleChange_editCcoForm = (e) => {
    const formData = { ...this.state.formData };
    formData[e.target.name] = e.target.value;
    this.setState({ formData });
  };

  handleChange_editCcoForm_locations = (selectedLocations) =>
    this.setState({ formData: { ...this.state.formData, selectedLocations } });

  handleBlur_editCcoForm = (e) => this.validateForm(e.target.name);

  getDisabledLocOption = (option) => {
    const { projLocationList } = this.props;
    const genLoc = (projLocationList || []).find((l) => l.isGeneric);
    if (genLoc) return option.value === genLoc.locationId;
    return false;
  };

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "ccoNo":
        if (formData.ccoNo == null) formErrors.ccoNo = "CCO Number is required";
        else if (formData.ccoNo === "0") formErrors.ccoNo = "CCO Number cannot be 0";
        else formErrors.ccoNo = null;
        break;
      case "description":
        if (formData.description === "")
          formErrors.description = "Description is required";
        else formErrors.description = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { ccoNo, description } = this.state.formErrors;
    const { formData } = this.state;
    if (ccoNo || description || formData.ccoNo === "" || formData.description === "")
      return true;
    else return false;
  };

  handleSubmit_editCcoForm = async (e) => {
    e.preventDefault();
    const { projectId, dispatch, toggleEditCcoModal, isNew } = this.props;
    const formData = { ...this.state.formData };
    formData.projectId = projectId;
    formData.ccoNo = parseInt(formData.ccoNo, 10) || 0;
    formData.supplementNo = parseInt(formData.supplementNo, 10) || 0;
    formData.locationIds =
      formData.selectedLocations && formData.selectedLocations.length > 0
        ? formData.selectedLocations.map((l) => l.value)
        : [];
    if (!this.formIsIncomplete()) {
      if (isNew) await dispatch(ccoActions.add(formData));
      else await dispatch(ccoActions.update(formData));
      this.resetFormData();
      toggleEditCcoModal();
    }
  };

  resetFormData = () => {
    const formData = {
      projectId: 0,
      ccoId: 0,
      ccoNo: "",
      supplementNo: "",
      description: "",
    };
    this.setState({ formData });
  };

  render() {
    const { formData, formErrors } = this.state;
    const { showEditCcoModal, toggleEditCcoModal, projLocationList, isNew } = this.props;
    const closeBtn = (
      <button className="close" onClick={toggleEditCcoModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditCcoModal}
          toggle={toggleEditCcoModal}
          className={this.props.className}
          size={"ml"}
          fade={false}
        >
          <ModalHeader
            toggle={toggleEditCcoModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon={isNew ? "plus" : "edit"} className="fa-fw mr-2" />
            {isNew ? "Add New CCO" : "Edit CCO"}
          </ModalHeader>
          <ModalBody>
            <form
              id="editCcoForm"
              onSubmit={this.handleSubmit_editCcoForm}
              autoComplete={"off"}
            >
              <div className="card m-2">
                <div className="card-body">
                  <div className="form-row form-group mb-2">
                    <label htmlFor="ccoNo" className="col-sm-3 col-form-label">
                      <b>CCO No:</b>*
                    </label>
                    <div className="col-sm-3">
                      <input
                        type="number"
                        name="ccoNo"
                        id="ccoNo"
                        className="form-control"
                        maxLength="3"
                        value={formData.ccoNo}
                        onChange={this.handleChange_editCcoForm}
                        onBlur={this.handleBlur_editCcoForm}
                      />
                      {formErrors.ccoNo && (
                        <span className="error-small">
                          <small>{formErrors.ccoNo}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="code" className="col-sm-3 col-form-label">
                      Supplement No:
                    </label>
                    <div className="col-sm-3">
                      <input
                        type="text"
                        name="supplementNo"
                        id="supplementNo"
                        className="form-control"
                        maxLength="2"
                        value={formData.supplementNo}
                        onChange={this.handleChange_editCcoForm}
                        onBlur={this.handleBlur_editCcoForm}
                      />
                      {formErrors.code && (
                        <span className="error-small">
                          <small>{formErrors.code}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-2">
                    <label htmlFor="description" className="col-sm-3 col-form-label">
                      <b>Description:</b>*
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        name="description"
                        id="description"
                        className="form-control"
                        maxLength="300"
                        value={formData.description}
                        onChange={this.handleChange_editCcoForm}
                        onBlur={this.handleBlur_editCcoForm}
                      />
                      {formErrors.description && (
                        <span className="error-small">
                          <small>{formErrors.description}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-0">
                    <label htmlFor="locations" className="col-sm-3 col-form-label">
                      <b>Location(s):</b>*
                    </label>
                    <div className="col-sm-9">
                      <Select
                        name="ccoLocations"
                        id="ccoLocations"
                        value={formData.selectedLocations}
                        options={(projLocationList || []).map((l) => ({
                          value: l.locationId,
                          label: l.name,
                        }))}
                        onChange={this.handleChange_editCcoForm_locations}
                        isOptionDisabled={(option) => this.getDisabledLocOption(option)}
                        placeholder="(Select location(s) for this CCO)"
                        isMulti
                        isClearable
                        isSearchable
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <div className="form-row form-group mb-0">
              <input
                className="btn btn-primary"
                name="submitEditCcoButton"
                type="submit"
                form="editCcoForm"
                onClick={this.handleSubmit_editCcoForm}
                value={isNew ? "Add" : "Save"}
                disabled={this.formIsIncomplete()}
              />{" "}
              <button
                className="btn btn-secondary ml-2"
                color="secondary"
                onClick={toggleEditCcoModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projLocationList: state.locations.projLocationLists[ownProps.projectId] || null,
  ccoDetails: state.ccos.openCcoDetails[ownProps.projectId]
    ? state.ccos.openCcoDetails[ownProps.projectId][ownProps.ccoId] || null
    : null,
});

export default connect(mapStateToProps)(EditCcoModal);
